/**
 * DATA LAYER: PREGUNTAS OVERLAY
 * Se encarga de la comunicación HTTP con la API de Preguntas.
 */

export const GetPreguntasConfig = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}preguntas/config`);
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SetPreguntasConfig = async (config) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}preguntas/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(config)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const TogglePreguntasVisibility = async (visible) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}preguntas/toggle-visibility`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ visible })
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const CreatePregunta = async (pregunta) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}preguntas`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(pregunta)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const UpdatePregunta = async (id, pregunta) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}preguntas/${id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(pregunta)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const DeletePregunta = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}preguntas/${id}`, {
            method: 'DELETE'
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SelectPregunta = async (id) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}preguntas/select/${id}`, {
            method: 'POST'
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};
